/**
 * AUTOGENERATED FILE. DO NOT EDIT.
 *
 * This file is generated by running yarn i18n:build, do not edit it manually.
 *
 * If you wish to update it, please run yarn i18n:build.
 */
/* eslint-disable no-restricted-imports */
import {i18n} from "@lingui/core";
import * as React from "react";

import {RequestInfo} from "@khan/shared-core";

// We statically import the English strings as we use them as a fallback
// for locales that don't have any translations. Additionally, it improves
// the performance of the English site by not having to load the strings at
// runtime.
// NOTE(john): This is replaced with the actual English strings in the build
// process.
const enStrings = {"oZyG4C":["Continue with Google"],"Tk3V+k":["Logging you in..."],"Kzy2d8":["More Info"],"sW5OjU":["required"],"LLAa/9":["Optional"],"y5p2bQ":["Did you know?"],"XnGvPC":["Regardless of who you are, mastering even just one more skill on Khan Academy results in learning gains."],"I4wbpi":["Learners have spent ",["actualMinutes"]," billion minutes learning on Khan Academy. ",["approxMinutes"]," billion minutes is equivalent to ",["actualYears"]," years."],"aIXCVN":["Your browser blocked a popup window required for logging in. Please click on the new Continue with Google button and try logging in again."],"JbFmLD":["Your browser blocked third-party cookies required for logging in. Please change your browser settings to allow cookies on khanacademy.org."],"zn1Xmb":["You closed the popup window before logging in. If that was a mistake, try logging in again."],"Yb2vtw":["You are currently logged in to another Google account. Please log out of that account and try again."],"1x3wHL":["Your invitation was not found. Please try clicking the link in your email again."],"yl7Nu2":["Oops! Something went wrong. Please try again."],"Xo7rk9":["Your browser blocked a popup window required for logging in. Please change your browser settings to allow popups from khanacademy.org."],"mALQCE":["Oops. Something went wrong. Please try again."],"X7283E":["Quiz ",["0"]],"rcXik1":["Quiz"],"LxT/yl":["Unit test"],"9bX4Wo":["Millions of students lack opportunity. <0>Together</0>, we can give it to them."],"iPSP0A":["We are a nonprofit with the mission to provide a free, world-class education to anyone, anywhere"],"IQo1Ve":["Provide a free, high-quality education for <0>anyone, anywhere</0> in the world"],"IbqT6z":["With a low-cost mobile phone, a learner anywhere in the world has access to the same Khan Academy lessons as students in the world’s best schools. Help bring more courses, translated into more languages, to students ready to learn."],"aLbsmG":["Support learning everywhere"],"BP2WDf":["Bring world-class learning to <0>every classroom</0>"],"YLtASg":["Every student deserves to step into a classroom equipped with the best resources. Help give teachers free, powerful tools and lessons that enable all students to reach their full potential."],"cnkz3S":["Support every classroom"],"M89r/Z":["<0>Equalize college access</0> with free, official practice for the SAT"],"FVxdSR":["Success on high-stakes exams shouldn’t depend on your family’s ability to pay for test prep. Khan Academy’s free SAT practice helps students raise their scores, independent of their ethnicity or family income. Help today’s hardest-working high school students achieve their college dreams."],"i9B3tn":["Support college access"],"S/lyp3":["Make sure <0>every child</0> is ready for kindergarten"],"TGlMZs":["No child should start kindergarten already behind their peers. Khan Kids is our free app—with no ads—that sparks a lifelong love of learning in every child, rich or poor."],"oYcqt1":["Support early learning"],"PKePKr":["How can you help level the playing field?"],"wJBp3/":["<0>Level</0> the playing field"],"UXqvFV":["Millions of students lack opportunity. You can give it to them. Just $10 a month can change a life."],"5CN5Wc":["Give today"],"c8Wv3m":["Jump to: About Khan Academy"],"5hkhWs":["Everyone is born with a desire to learn. They only need the chance."],"1IN/NM":["“Khan Academy gave me a reason to wake up hopeful for a new day. Had I never come across it, my life story would be like millions of other Afghan girls stuck in the cage of ignorance. Thank you for helping me free that cage.”"],"09zau3":["AFGHANISTAN"],"LPst5D":["You can bring education to the world."],"a6uIPV":["<0>",["0"],"+ million</0> people learning with us"],"L5hG5k":["<0>",["0"]," billion</0> practice questions completed"],"xIhXnI":["<0>",["0"],"</0> countries"],"XiuRvP":["<0>",["0"],"+</0> languages"],"j9KU7q":["“It is rare that you can reach a lot of people and reach them deeply. Khan Academy’s impact has both breadth and depth. That is why I donate.”"],"jixnYM":["Palo Alto, CA"],"Mqy/Zy":["United States"],"docLSc":["Learn more about Khan Academy"],"SkvV9f":["Meet our leadership team"],"ALBsPe":["Learn more about our leadership team’s roles, backgrounds, and how they are changing the world of education."],"IFiusY":["Read our annual report"],"9ceeM4":["We’re grateful for our donors and honored to share the work they make possible. We’re also excited to share the success of students and teachers using Khan Academy."],"7v9rS3":["View our Annual Report"],"4G8Q+n":["View our Annual Report (English)"],"MwvtKO":["Become a corporate partner"],"aMnFAt":["Inspire your employees to celebrate and support learning, and elevate your company’s role as a global leader in education."],"zRx56i":["Contact our partnership team"],"mQn6gx":["About Khan Academy"]};

let results: Record<string, string | string[]> | undefined = undefined;
let promise: Promise<void> | null = null;

// We keep track of locales that are missing translations so we can load the
// English strings for those locales.
// NOTE(john): This array is replaced with the list of locales.
const missingTranslations: string[] = ["ur","zh-hant","sgn-us","is","en-x-rtl","zu","xh","th","sw","fa","ms","he","fa-af","sq"];

// We keep track of locales that have been bundled together in the same file
// so we can load them all at once.
const extraLocales: string[] = ["te","or","ko","ka","bn","pt-pt"];

/**
 * Load the i18n strings for the current locale and add them to the Lingui i18n
 * instance. This uses Suspsense so you'll want to make sure that your
 * component is wrapped in a Suspense (for loading) and an ErrorBoundary
 * (for errors).
 *
 * This function is called by the LoadStrings component, which is a Loadable
 * component that loads the strings for a route and all descendant imports.
 *
 * You can use this directly or you can use the withStrings HoC to load
 * strings for a component.
 */
export const useStrings = () => {
    if (results) {
        return results;
    }

    const locale = RequestInfo.kaLocale;

    // If the locale is English, or doesn't have any translations, we don't need to load
    // any additional strings.
    if (locale === "en" || missingTranslations.includes(locale)) {
        // Load the English strings into Lingui. This serves as a fallback for
        // locales that don't have any translations (and the actual strings for the English
        // locale).
        results = enStrings;
        i18n.load(locale, results);
        return results;
    }

    if (!promise) {
        promise = (async () => {
            const locale = RequestInfo.kaLocale;
            const localeFile = extraLocales.includes(locale) ? "extra" : locale;

            if (process.env.NODE_ENV === "production") {
                const result = (await import(`./lingui/${localeFile}.json`))
                    .default;
                results = localeFile === "extra" ? result[locale] : result;
            } else {
                results = {};
            }

            // Load the strings into Lingui
            i18n.load(locale, {...enStrings, ...results});

            promise = null;
        })();
    }

    throw promise;
};

/**
 * The HOC to load i18n strings for a route and all descendant imports.
 *
 * Examples:
 *
 * - export default withStrings(WrappedComponent);
 *
 * - export default compose(
 *      withStrings,
 *      withRouter
 *   )(WrappedComponent);
 */
export const withStrings = <C extends object>(
    WrappedComponent: React.ComponentType<C>,
) => {
    if (process.env.NODE_ENV === "test") {
        return WrappedComponent;
    }

    // Try to create a nice displayName for React Dev Tools.
    const displayName =
        WrappedComponent.displayName || WrappedComponent.name || "Component";

    // Creating the inner component.
    const WrapperComponent = (props: C): React.ReactNode => {
        useStrings();
        return <WrappedComponent {...(props as C)} />;
    };

    WrapperComponent.displayName = `withStrings(${displayName})`;

    return WrapperComponent;
};
